import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, TextField, Button } from '@mui/material';

const SelfDescribeDialog = ({
    open,
    questionText,
    value,
    onClose,
    onSave,
    onChange,
}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.5rem', color: '#000' }}>
                {questionText || 'Describe Yourself'}
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center', p: 3 }}>
                <Typography sx={{ mb: 2, fontSize: '1.1rem', color: '#555' }}>
                    Please provide more information below:
                </Typography>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Please describe"
                    type="text"
                    fullWidth
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    sx={{ mt: 2 }}
                />
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', p: 3 }}>
                <Button
                    variant="contained"
                    color="error"
                    onClick={onSave}
                    sx={{
                        width: '100px',
                        backgroundColor: '#bc2534',
                        fontWeight: 'bold',
                        '&:hover': { backgroundColor: '#a81e2e' },
                        marginRight: '15px',
                    }}
                >
                    YES
                </Button>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                        width: '100px',
                        borderColor: '#ccc',
                        color: '#bc2534',
                        fontWeight: 'bold',
                        '&:hover': { backgroundColor: '#f1f1f1' },
                    }}
                >
                    DISCARD
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SelfDescribeDialog;
